<template>
    <div class="investor-ident">
        <div class="investor-main" v-html="content"></div>
        <div class="exclusive-enjoy">
            <button class="bigBtn default-button" @click="agree">确认成为合格投资者</button>
        </div>
    </div>
</template>
<script>
    import qs from "qs";
    import {request} from "../../../utils/request";
    import {callHandler} from "@/utils/bridge.js";

    export default {
        name: "investorIdent",
        data() {
            return {
                content: "",
                sesameCode: "",
                sesameSource: "",
                token: "",
                assessmentType: ""
            };
        },
        beforeMount() {
            const urlParams = this.$queryUrl(location.href);
            // const { token = "1c136f7c60ff7ba244f7ef73feb450f1:1", sesameCode = "zma157407415667714258" } = urlParams; //测试数据
            const {token, sesameCode} = urlParams;
            this.token = decodeURIComponent(token || "");
            this.sesameCode = sesameCode;
            this.getContent()
                .then(res => {
                    const {data} = res;
                    this.content = data.content;
                    this.assessmentType = data.assessmentType;
                })
                .catch(err => {
                    // this.$toast(err);
                });

        },
        methods: {
            async getContent() {
                return await this.$request({
                    url: "/h5/sesame/qualifiedProtocol.json",
                    data: this.$qs.stringify({
                        sesameCode: this.sesameCode,
                        token: this.token
                    })
                });
            },
            //是否为合格投资者
            async check(type) {
                return await this.$request({
                    url: "app/sesame/sesameValidate.ason",
                    data: qs.stringify({
                        data: JSON.stringify({
                            appReqData: {
                                sesameCode: this.sesameCode,
                                validateType: type,
                                token: this.token
                            },
                            token: this.token
                        })
                    })
                });
            },
            agree: (function () {
                let flag = true;
                return function () {
                    if (flag) {
                        flag = false;
                        this.$request({
                            url: "/h5/sesame/agreeProtocol.json",
                            data: this.$qs.stringify({
                                token: this.token,
                                sesameCode: this.sesameCode,
                                protocolType: 1
                            })
                        })
                            .then(res => {
                                flag = true;
                                const {data} = res;
                                request({
                                    url: "/h5/sesame/riskValidate.json",
                                    data: this.$qs.stringify({
                                        token: this.token,
                                        assessmentType: this.assessmentType,
                                    })
                                }).then(res2 => {
                                    const {code} = res2;
                                    if (code === "200") {
                                        callHandler("xhShowSesameInfo", {
                                            sesameCode: this.sesameCode
                                        });
                                    } else {
                                        this.$toast("合格投资者认证已完成，请进行风险测评", 2000, function () {
                                            //跳转到 测评页面
                                            this.$router.push({
                                                name: "riskAssessment",
                                                query: {
                                                    token: this.token,
                                                    assessmentType: this.assessmentType,
                                                    type: "lgs", //合格投资者认定,类固收
                                                    sesameCode: this.sesameCode
                                                }
                                            });
                                        });
                                    }
                                }).catch(e => {
                                    flag = true;
                                    this.$toast(e);
                                });

                            })
                            .catch(e => {
                                flag = true;
                                this.$toast(e);
                            });
                    }
                };
            })()
        }
    };
</script>
<style lang="less">
    .investor-ident {
        .investor-main {
            width: 100%;
            background: #fff;
            border-radius: 20px;
            box-sizing: border-box;
            padding: 12px 16px;
            margin-bottom: 80px;
        }

        font-size: 12px;
        color: #888888;
        text-align: left;
        line-height: 24px;

        .investor-indent {
            text-indent: 26px;
        }
    }
</style>
